import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { usePresetsListFilterFields } from './hooks/usePresetsListFilterFields';

export const PresetsListFilterChips: React.FC = () => {
  const fields = usePresetsListFilterFields({ resetDependentOnChange: false });

  return <FilterChips fields={fields} />;
};
